import { TestContact } from './TestContact.js';
import { Alert, SectionHeading } from './ui.js';

/**
 * The contact evaluator, behind the support route.
 *
 * It runs a made-up contact through identity resolution and the policy engine and shows
 * what WOULD happen — genuinely useful for confirming a configuration change, and not a
 * customer decision. So it is not in any navigation: support reaches it at
 * `/support/diagnostics` (or `?tab=support-diagnostics`), and only an owner or admin sees
 * the tool itself.
 */
export function SupportDiagnostics({ role }: { role: string | null }) {
  if (role !== 'owner' && role !== 'admin') {
    return <Alert tone="info">This page is only available to workspace owners and admins.</Alert>;
  }
  return (
    <div className="space-y-4">
      <SectionHeading
        title="Support diagnostics"
        hint="Check what the system would do with a contact, without doing it."
      />
      <TestContact />
    </div>
  );
}
